var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1 7.72191C5.1 9.61667 5.86469 11.3338 7.1 12.5799V23.1781L12 20.7281L16.9 23.1781V12.5799C18.1353 11.3338 18.9 9.61667 18.9 7.72191C18.9 3.91115 15.8108 0.821915 12 0.821915C8.18924 0.821915 5.1 3.91115 5.1 7.72191ZM12 2.62191C9.18335 2.62191 6.9 4.90526 6.9 7.72191C6.9 9.23223 7.55547 10.5883 8.60023 11.5234C9.50309 12.3315 10.6932 12.8219 12 12.8219C13.3068 12.8219 14.497 12.3315 15.3999 11.5233C16.4446 10.5882 17.1 9.23223 17.1 7.72191C17.1 4.90526 14.8166 2.62191 12 2.62191ZM8.9 13.8877C9.55511 14.2177 10.2701 14.4464 11.024 14.5533C11.3429 14.5985 11.6688 14.6219 12 14.6219C12.3543 14.6219 12.7025 14.5951 13.0426 14.5435C13.772 14.4329 14.4642 14.208 15.1 13.8877V20.2656L12 18.7156L8.9 20.2656V13.8877Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.a0d8b51067418ee30a8e5e7b3e145923.svg";
export { ForwardRef as ReactComponent };